import React from "react";
import { useTranslation } from "react-i18next";
import LegalDocumentView, { LegalSection } from "./LegalDocumentView";

const OperationalLeasingAgreement: React.FC = () => {
  const { t } = useTranslation();

  const sections: LegalSection[] = [
    {
      title: t("legal.operationalLeasingAgreement.sections.general.title"),
      subsections: t(
        "legal.operationalLeasingAgreement.sections.general.subsections",
        { returnObjects: true }
      ) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
      }>,
    },
    {
      title: t("legal.operationalLeasingAgreement.sections.leaseTerm.title"),
      subsections: t(
        "legal.operationalLeasingAgreement.sections.leaseTerm.subsections",
        { returnObjects: true }
      ) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
      }>,
    },
    {
      title: t("legal.operationalLeasingAgreement.sections.leasePayments.title"),
      subsections: t(
        "legal.operationalLeasingAgreement.sections.leasePayments.subsections",
        { returnObjects: true }
      ) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
      }>,
    },
    {
      title: t("legal.operationalLeasingAgreement.sections.ownership.title"),
      subsections: t(
        "legal.operationalLeasingAgreement.sections.ownership.subsections",
        { returnObjects: true }
      ) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
      }>,
    },
    {
      title: t("legal.operationalLeasingAgreement.sections.useOfProducts.title"),
      subsections: t(
        "legal.operationalLeasingAgreement.sections.useOfProducts.subsections",
        { returnObjects: true }
      ) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
      }>,
    },
    {
      title: t("legal.operationalLeasingAgreement.sections.conditionOfProducts.title"),
      subsections: t(
        "legal.operationalLeasingAgreement.sections.conditionOfProducts.subsections",
        { returnObjects: true }
      ) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
      }>,
    },
    {
      title: t("legal.operationalLeasingAgreement.sections.liability.title"),
      subsections: t(
        "legal.operationalLeasingAgreement.sections.liability.subsections",
        { returnObjects: true }
      ) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
      }>,
    },
    {
      title: t("legal.operationalLeasingAgreement.sections.indemnity.title"),
      subsections: t(
        "legal.operationalLeasingAgreement.sections.indemnity.subsections",
        { returnObjects: true }
      ) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
      }>,
    },
    {
      title: t("legal.operationalLeasingAgreement.sections.breach.title"),
      subsections: t(
        "legal.operationalLeasingAgreement.sections.breach.subsections",
        { returnObjects: true }
      ) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
      }>,
    },
    {
      title: t("legal.operationalLeasingAgreement.sections.delivery.title"),
      subsections: t(
        "legal.operationalLeasingAgreement.sections.delivery.subsections",
        { returnObjects: true }
      ) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
      }>,
    },
    {
      title: t("legal.operationalLeasingAgreement.sections.productLiability.title"),
      subsections: t(
        "legal.operationalLeasingAgreement.sections.productLiability.subsections",
        { returnObjects: true }
      ) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
      }>,
    },
    {
      title: t("legal.operationalLeasingAgreement.sections.governingLaw.title"),
      subsections: t(
        "legal.operationalLeasingAgreement.sections.governingLaw.subsections",
        { returnObjects: true }
      ) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
      }>,
    },
  ];

  return (
    <div className="space-y-6">
      <header className="border-b border-slate-200 pb-6">
        <h2 className="text-3xl font-bold tracking-tight text-slate-950 md:text-4xl">
          {t("legal.operationalLeasingAgreement.title")}
        </h2>
        <p className="mt-3 text-base font-medium text-blue-700">
          {t("legal.operationalLeasingAgreement.subtitle")}
        </p>
        <p className="mt-4 max-w-4xl text-base leading-8 text-slate-700 md:text-lg">
          {t("legal.operationalLeasingAgreement.description")}
        </p>
      </header>

      <LegalDocumentView sections={sections} />
    </div>
  );
};

export default OperationalLeasingAgreement;
